'use strict';

// Stores
const SocialNetworkStore = require('../../global/stores/SocialNetworkStore');
const UserSocialNetworkStore = require('../../user/stores/UserSocialNetworkStore');

const userSocialNetworkActions = {

    addSocialNetwork(actionContext, payload, done) {
        const {name, data: userPreferences} = payload;

        const socialNetworkStore = actionContext.getStore(SocialNetworkStore);
        const socialNetwork = socialNetworkStore.getSocialNetwork(name);

        const userSocialNetworkStore = actionContext.getStore(UserSocialNetworkStore);
        const collection = userSocialNetworkStore.getCollection();

        collection
            .addNetwork({socialNetwork, userPreferences})
            .then(response => {
                actionContext.dispatch('user:socialNetwork:connect', {
                    socialNetwork: response
                });
                done();
            })
            .catch(error => done(error));
    },

    updateSocialNetwork(actionContext, payload, done) {
        const {name, data: userPreferences} = payload;

        const userSocialNetworkStore = actionContext.getStore(UserSocialNetworkStore);
        const collection = userSocialNetworkStore.getCollection();

        collection
            .updateNetwork({name, userPreferences})
            .then(response => {
                actionContext.dispatch('user:socialNetwork:update', {
                    socialNetwork: response
                });
                done();
            })
            .catch(error => done(error));
    },

    removeSocialNetwork(actionContext, payload, done) {
        const {name} = payload;

        const userSocialNetworkStore = actionContext.getStore(UserSocialNetworkStore);
        const collection = userSocialNetworkStore.getCollection();

        collection
            .removeNetwork(name)
            .then(response => {
                actionContext.dispatch('user:socialNetwork:disconnect', {
                    socialNetwork: response
                });
                done();
            })
            .catch(error => {
                done(error);
            });
    }

};

module.exports = userSocialNetworkActions;



// WEBPACK FOOTER //
// ./assets/js/user/actions/userSocialNetworkActions.es.js